var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatus25 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 4.5C12.9849 4.5 13.9602 4.69399 14.8701 5.0709C15.7801 5.44781 16.6069 6.00026 17.3033 6.6967C17.9997 7.39314 18.5522 8.21993 18.9291 9.12988C19.306 10.0398 19.5 11.0151 19.5 12L12 12V4.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatus25);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status-25.e2db13167d6fa6c797b5f3aed2e24f4c.svg";